export type TrackingData = {
  id: string;
  url?: string;
  campaign?: string;
  category?: 'homepage' | string;
  brand?: 'jb' | string;
  type?: 'carousel' | 'leaderboard' | string;
  position?: number;
};

export const trackingDataToDataAttributes = (trackingData: TrackingData | undefined) => {
  if (!trackingData) return {};
  return {
    'data-gaip': 'true',
    ...Object.entries(trackingData).reduce(
      (acc, [key, value]) => ({ ...acc, [`data-gaip-${key}`]: value?.toString() ?? '' }),
      {}
    ),
    'data-gaip-has-onclick': !!trackingData?.url,
  };
};
